import { useApiPrivateRequest } from "../hooks/useApi";

export interface LlmInfo {
  name: string;
  displayName: string;
  description?: string;
  speed: number;
  intelligence: number;
}

export const useGetLlmInfoList = () => {
  const { data: llmInfo, call, isLoading } = useApiPrivateRequest<LlmInfo[]>();

  const getLlmInfo = async () => {
    await call("/chats/llm", "GET");
  };

  return { llmInfo, getLlmInfo, isLoading };
};
